// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames   from 'fg-frontend/src/lib/classNames';

const fragments = {
  FILTER_BTN: '[data-fragment="PFC.button"]',
};

class ProductFilterCollapse extends WebComponent {

  static defaultProps = {
    btnIcon:        'filter-circle',
    btnClassName:   'btn btn--show-filter',
    messages:       {
      showFilter: 'Zobrazit filtry',
    },
    buttonTemplate: (data) => `<button type="button" class="${ data.className }" data-fragment="PFC.button">
      <span class="button-label">${ data.label }</span>
      <span class="ico">
        <svg class="svg-icon"><use xlink:href="/ver/20210702132257/build/img/svg/svg-sprite.svg#${ data.icon }"></use></svg>
      </span>
    </button>`,
  }

  constructor(props) {
    super(props);
    this.state = {
      filterOpened: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    this.renderButton();
    this.on('click', fragments.FILTER_BTN, this.handleClick);
  }

  renderButton() {
    let btn = this.props.buttonTemplate({
      className: this.props.btnClassName,
      label:     this.i18n('showFilter'),
      icon:      this.props.btnIcon,
    });
    const {
      insertButtonBefore,
    } = this.props;

    if (insertButtonBefore) {
      this.element.insertAdjacentHTML('afterbegin', btn);
    }
    else {
      this.element.insertAdjacentHTML('beforeend', btn);
    }
  }

  handleClick(e) {
    e.preventDefault();
    const { filterOpened } = this.state;

    this.setState({
      filterOpened: !filterOpened,
    });

    const btnLabel = this.element.querySelector('.btn--show-filter .button-label');

    if (filterOpened) {
      btnLabel.innerHTML = this.i18n('showFilter');
    }
    else {
      btnLabel.innerHTML = this.i18n('hideFilter');
    }

    return false;
  }

  update() {
    const { filterOpened } = this.state;
    // pridame tridu `--closed`, aby se filtry zobrazovaly by-default, pokud kixne JS
    classNames(this.element, { 'category-filter__container--closed': !filterOpened });
  }
}

export default ProductFilterCollapse;



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/ProductFilterCollapse.js